<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="发布补丁"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="65%"
    @beforeopen="onOpen"
  >
    <el-form :model="item" ref="itemform" label-width="150px" :rules="rules">
      <el-form-item label="更新日志" prop="UpdateLog">
        <mavon-editor
          ref="md"
          v-model="log"
          :toolbars="toolbars"
          :box-shadow="true"
        />
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          accept=".zip"
          :action="uploadUrl"
          :headers="uploadHeader"
          :multiple="false"
          :limit="1"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import mavonEditor from 'mavon-editor';

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem('jwtToken')}`,
        Accept: 'application/json',
      },
      uploadUrl: '',
      log: '',
      item: {
        UpdateLog: '',
        Url: '',
        Md5: '',
      },
      submitting: false,
      rules: {
        VerNumber: [
          { required: true, message: '版本号', trigger: 'blur' },
        ],
        // UpdateLog: [
        //   { required: true, message: '更新日志', trigger: 'blur' },
        // ],
      },
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        // imagelink: true, // 图片链接
        // code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        // readmodel: true, // 沉浸式阅读
        // htmlcode: true, // 展示html源码
        // /* 1.3.5 */
        // undo: true, // 上一步
        // redo: true, // 下一步
        // trash: true, // 清空
        // /* 1.4.2 */
        // navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        // preview: true, // 预览
      },
    };
  },
  methods: {
    onOpen() {
      this.uploadUrl = `api/branch/transfile/${this.value.ID}`;
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.submitting = false;
      this.preurl = '';
      this.funurl = '';
      this.log = '';
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message({
            type: "warning",
            message: "请上传附件",
            duration: 1500,
          });
          return;
        }
        this.submitting = true;
        this.$refs.upload.submit();
      });
    },
    handleSuccess(response) {
      this.item.Url = response.Url;
      this.item.Md5 = response.Md5;
      this.item.UpdateLog = mavonEditor.markdownIt.render(this.log || '');
      this.$axios.post(`software/version/${this.value.ID}/branch`, this.item).then(() => {
        this.$message({
          message: '上传成功!',
          type: 'success',
        });
        this.onClose();
        this.$emit('form:saved');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.submitting = false;
      });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
  },
};
</script>
